import { callApi } from "../../utils/common.utils";
import axios from 'axios';
import { UPFLOW_URL } from "../../constants/app.constants";

// export const fetchBenchmarkInvoicingList = async (userId: string | null) => {
//   const payLoad = {
//     id: userId,
//   };
//   return callApi("getInvoicing", payLoad, "getData");
// };

export const fetchBenchmarkInvoicingList = async () => {
  try {
    const quickbookId = localStorage.getItem("Intake_QuickbooksAccount"); 

    console.log("QuickbookID:", quickbookId);

const response = await axios.post(
  `${UPFLOW_URL}/api/controller/upflowIntegration.php`,
  { quickbookId },
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);

    console.log("[utils] Received data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching invoicing data:", error);
    throw error;
  }
};

// export const fetchBenchmarkInvoicingList = async () => {
//   try {
//     const quickbookId = localStorage.getItem("Intake_QuickbooksAccount");
//     const companyName = localStorage.getItem("Name"); // <-- new

//     console.log("QuickbookID:", quickbookId);
//     console.log("CompanyName:", companyName);

//     const response = await axios.post(
//       `${UPFLOW_URL}/api/controller/upflowIntegration.php`,
//       { quickbookId, companyName }, // <-- send both
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     console.log("[utils] Received data:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching invoicing data:", error);
//     throw error;
//   }
// };

// export const fetchBenchmarkInvoicingList = async () => {
//   const response = await axios.get(
//     "http://localhost:8081/benchmark_api/api/controller/testing1.php"
//   );
//   return response.data;
// };




export const printBenchmarkInvoice = async (
  userId: string | null,
  invoiceId: number
) => {
  const payLoad = {
    id: userId,
    invoiceId: invoiceId,
  };
  return callApi("printInvoice", payLoad, "getData");
};
